import { render, staticRenderFns } from "./NewsListTest.vue?vue&type=template&id=2b48d903&scoped=true&lang=pug&"
import script from "./NewsListTest.vue?vue&type=script&lang=js&"
export * from "./NewsListTest.vue?vue&type=script&lang=js&"
import style0 from "./NewsListTest.vue?vue&type=style&index=0&id=2b48d903&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b48d903",
  null
  
)

export default component.exports